import { defectColors, greyModernScale } from '../themes/colors';

export const DEFECT_FALLBACK_COLOR = defectColors[0] ?? '#000000';

export const TOOLTIP_BG_DEFAULT_COLOR = greyModernScale[800] ?? '#202939';
